import PropTypes from 'prop-types';

const StepProps = {
  /**
   * Is called when this step has completed its work on the `complete` member.
   * @param {Object} response
   */
  onStepCompleteSuccess: PropTypes.func,
  /**
   * Is called when this step has completed its work on the `complete` member.
   * @param {Object} error
   */
  onStepCompleteFailed: PropTypes.func,
  /**
   * Is called when this step has been (in)validated
   * @param {Boolean} valid
   */
  onValidationChange: PropTypes.func,
  /**
   * The hash that refers to the current job. Available after completion of the 1st step.
   * @param {Object} error
   */
  hash: PropTypes.string,
}
export default StepProps;



// WEBPACK FOOTER //
// ./src/constants/StepProps.js